import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DiscoverPage = () => {
  const navigate = useNavigate();

  // Ensure the body background is white
  useEffect(() => {
    const originalBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#fff';
    return () => {
      document.body.style.backgroundColor = originalBg;
    };
  }, []);

  return (
    <div className="flex flex-col items-center min-h-screen bg-white p-8 w-full">
      <button
        onClick={() => navigate('/ai-agent')}
        className="absolute top-8 left-8 bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-lg shadow transition flex items-center"
        style={{ zIndex: 10 }}
      >
        Login
      </button>

      {/* Centered Logo, moved further up */}
      <img 
        src="/discover_page_arta_logo.png"
        alt="Arta Logo" 
        className="w-64 h-64 object-contain mt-10 mb-8 transform hover:scale-105 transition-transform duration-300"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "A.png";
        }}
      />

      {/* Left-aligned, wider content */}
      <div className="w-full max-w-4xl flex flex-col items-start text-left space-y-6">
        <h1 className="text-4xl font-bold text-[#253439] mb-4">About ArtaSupport Inc</h1>
        <p className="justified-text text-xl text-[#253439]">
          Headquartered in San Jose, California, ArtaSupport Inc. is currently in stealth mode. We are harnessing the power of advanced AI technologies to create innovative products and services for the enterprise market and look forward to sharing more in the near future.
        </p>
        <p className="justified-text text-xl text-[#253439] leading-relaxed">
            ArtaSupport is founded by experienced entrepreneurs who have successfully built innovative Security, Cloud, and Customer Support solutions for startups and global enterprises. Our leadership team combines deep technical expertise with a passion for creating forward-thinking products that enhance customer experience, streamline support operations, and drive business growth.
        </p>
        <p className="text-xl text-[#253439] leading-relaxed">
          If you would like to know more, please contact us at <a href="mailto:insights@artasupport.ai" className="text-cyan-500 hover:text-cyan-600 underline">insights@artasupport.ai</a>
        </p>
      </div>
    </div>
  );
};

export default DiscoverPage; 
